/* ===========================================================================
   BB LAUNCH FIXES — five small corrections from the 2026-10-27 code audit
   ---------------------------------------------------------------------------
   Self-contained override, same pattern as bb-flat-fee.js: loaded after
   box-builder.js from snippets/bb-assets.liquid (both lists). Remove its two
   entries there to revert everything below. Long term each one is a few
   lines inside box-builder.js (line numbers are from the 2026-10-27 file).

   1. MIN ITEMS ON EVERY STEP (box-builder.js BBPricing.blockReason, ~864)
      The 3-item minimum was only checked on step 1, so a shopper could
      remove items from the Box Summary on step 2-4 and check out with a
      box and a card but no goodies. Now the same "Keep Going!" alert shows
      on any step, and Checkout is blocked, while there are fewer than the
      minimum.

   2. CART ADD FAILURES ARE SHOWN, AND EDITS ARE SAFE (BBCart.submit, ~1491)
      If Shopify rejected the add (an item sold out while the box was being
      built), nothing was shown: the buttons just came back. And when
      editing a box from the cart, the old box was deleted from the cart
      BEFORE the new one was added, so a failed add lost the box. Now the
      new box is added first, the old one is removed after, and an error
      opens the alert popup with Shopify's reason.

   3. ITEMS NO LONGER IN THE CATALOG ARE DROPPED ON LOAD (pruneUnavailable,
      ~577). A saved box (sessionStorage) kept items that had since left
      the catalog, because the lookup fell back to the saved item itself.
      Now anything not in the loaded catalog is removed, same as sold out.

   4. THE BOX ESTIMATE IS THE REAL CHEAPEST BOX (BBConfig.sizing.prices)
      The $6 shown on step 1 came from a typed theme setting. Now it is the
      lowest price among the boxes loaded for step 2 (the mailer), so a
      price change in Shopify flows through; the setting is the fallback.

   5. AN EMPTY BOX COLLECTION FALLS BACK TO ANOTHER TIER (BBConfig.boxes)
      boxesForTier used `boxes[key] || boxes.small`, and an empty list is
      truthy, so a cleared tier collection showed "No boxes available" and
      dropped the chosen box. Now an empty tier borrows the first non-empty
      one, so the three box collection settings can point at one collection.

   6. DESKTOP SIDEBAR OPENS ONLY THE CURRENT STEP'S SECTION (BBShell
      .syncAccordions, ~982). A section stayed open once it was filled, so
      on step 3 The Box (with the Keep going! add-ons inside it) sat open
      above The Card and pushed the card you had just picked below the
      fold. Now on desktop only the current step's section opens when the
      step changes; a section you open by hand stays as you left it. Phones
      keep the old rule: the drawer is opened to review, so filled sections
      stay open there.

   7. CHECKOUT IS NOT GREYED OUT ON THE REVIEW STEP (armReviewGate, ~1730)
      The core disabled Checkout Now until the END of the review panel had
      scrolled into view, so on a normal laptop the button sat grey with no
      explanation until the shopper happened to scroll (Moshe, Oct 27). The
      page already says "give everything one last look"; the gate is off.

   8. DESKTOP REVIEW: BOTH CHOICES UNDER THE SUBTOTAL (Moshe, Oct 27)
      Checkout Now lived in the step bar and Proceed to Cart at the bottom of
      the review panel, far apart. The sidebar receipt now ends with Checkout
      Now plus the cart option (its note + label come from the review
      section settings). Each button just clicks the original one, so all
      the existing checks and cart logic run unchanged. Styles and the
      desktop-only hiding of the old bottom button: bb-mobile-compact.css.

   9. STEP CHANGES LAND AT THE TOP ON PHONES (BBSteps.go, ~2497)
      The core scrolls to the top with a smooth scroll, then hides the old
      panel 340ms later; on iPhones the page getting shorter mid-scroll
      stops the scroll partway, so Review opened half-way down (Moshe,
      Oct 27). Now the jump is instant, and repeated once the old panel is
      gone.

   10. POPUP GALLERY + ZOOM (phones; Moshe, Oct 27, redone the same night)
      Swipe or tap the popup photo for the next image, dots under it,
      thumbnails hidden; a "view larger" pill on the photo opens the
      builder's full-screen viewer (BBZoom) on that image; inside the viewer
      a tap toggles 2.5x. Styles: bb-mobile-compact.css + bb-launch-tweaks.css.

   11. BACK IN THE STEP BAR ON THE REVIEW STEP (phones; Moshe, Oct 27)
      With the My box pill gone on step 4 the bar had Checkout Now and an
      empty gap, while the round Back sat on top of the long title. A Back
      button is added to the bar (shown by CSS on phones at step 4 only); it
      clicks the review panel's own Back.

   12. DRAWER TOP PADDING MEASURED, NOT GUESSED (phones; Moshe, Oct 27)
      The drawer is a fixed overlay. On desktop Chrome "fixed" means the
      viewport, so it starts behind the sticky nav; on his iPhone WebKit
      placed it under the nav instead, which turned the 72px allowance into
      a 72px gap. Now, each time the drawer opens, the overlap between the
      nav and the drawer is measured and used as the padding.

   13. NO "$0.00" FOR THE CARD (Moshe, Oct 27 night)
      Greeting cards are free, so the price next to The Card in the Box
      Summary, on its line and on the review block is blanked while it is 0.
      A card with a real price shows it again automatically.

   14. SHEET GESTURES (phones; Moshe, Oct 27 night)
      The My box panel (full screen since 11pm) closes on a drag down past
      a third of the screen, a quick flick, or its own X (the 90px threshold
      "felt too fast", 11:15pm). Styles: bb-launch-tweaks.css.

   16. FREE-SHIPPING LINE WORDING + UNLOCKED STATE (Moshe, Oct 28)
      "$63.00 more for free shipping" instead of "You are $63.00 away from
      Free Shipping!", and .is-unlocked on the element for the check icon.
      Styles for every width: bb-launch-tweaks.css.

   17. SIZE EXPLAINER IS THE ONLY MESSAGE (Moshe, Oct 28, 10am)
      The core blanked the "How full is your box" message once the box had
      an item and later swapped in "Your box upgraded to ..."; now the
      explainer from the section setting is shown at all times.

   18. FREE SHIPPING IN THE PHONE STEP BAR (Moshe, Oct 28, 10:05am)
      The sticky "Your box" block reads "Your box · $13.00" over "$87 to
      free shipping" / "Free shipping unlocked", so the nudge is always in
      view while browsing, as it was on the old builder's sticky bar.

   15. BOXES ALREADY IN THE CART -> "ADD TO CART" (Moshe, Oct 27 night)
      When /cart.js has items, the review step's button reads "Add to cart"
      and goes to the cart page; the secondary cart option is hidden
      (bb-launch-tweaks.css, .bb-cart-has-items). Also restores the Back-
      from-checkout note that bb-checkout-back.js relies on (fix #2 had
      replaced its wrapper), and reloads the builder on Back from the cart.
   =========================================================================== */
(function () {
  "use strict";
  if (window.__bbLaunchFixes) return;
  window.__bbLaunchFixes = true;

  var PROP_BOX_ID = "_bb_box_id";
  var PROP_BOX_N = "_bb_box_n";
  var PROP_GROUP_LABEL = "Included in";

  function cfg() { return window.BBConfig || {}; }

  /* ---- 4 + 5: config fixes (read by the core at call time) --------------- */
  function fixBoxes() {
    var c = cfg();
    var boxes = c.boxes || {};
    var keys = ["small", "regular", "large"];
    var firstFull = null;
    keys.forEach(function (k) {
      if (!firstFull && Array.isArray(boxes[k]) && boxes[k].length) firstFull = boxes[k];
    });
    if (!firstFull) return;
    keys.forEach(function (k) {
      if (!Array.isArray(boxes[k]) || !boxes[k].length) boxes[k] = firstFull;
    });
    c.boxes = boxes;

    var cheapest = null;
    keys.forEach(function (k) {
      boxes[k].forEach(function (p) {
        if (!p || p.available === false) return;
        var vs = (p.variants || []).filter(function (v) { return v && v.available !== false; });
        var prices = vs.length ? vs.map(function (v) { return Number(v.price); }) : [Number(p.price)];
        prices.forEach(function (n) {
          if (isFinite(n) && n > 0 && (cheapest === null || n < cheapest)) cheapest = n;
        });
      });
    });
    if (cheapest === null) return;
    c.sizing = c.sizing || {};
    c.sizing.prices = { small: cheapest, regular: cheapest, large: cheapest };
  }

  /* ---- 3: drop saved items that are not in the loaded catalog ------------ */
  function inPool(variantId) {
    var id = String(variantId);
    var pool = (window.BBCatalog && window.BBCatalog.all) || [];
    for (var i = 0; i < pool.length; i++) {
      var p = pool[i];
      if (!p) continue;
      if (String(p.variantId) === id) return true;
      var vs = p.variants || [];
      for (var v = 0; v < vs.length; v++) if (String(vs[v].id) === id) return true;
    }
    return false;
  }

  var pruning = false;
  function pruneMissing() {
    var store = window.BBStore;
    if (pruning || !store || !store.get || !((window.BBCatalog && window.BBCatalog.all) || []).length) return;
    pruning = true;
    try {
      var state = store.get();
      Object.keys(state.items || {}).forEach(function (key) {
        var item = state.items[key];
        if (item && !inPool(item.variantId)) store.upsertItem(item, 0);
      });
      if (state.box && state.box.variantId && !inPool(state.box.variantId)) store.setBox(null);
      if (state.card && state.card.variantId && !inPool(state.card.variantId) && store.setCard) store.setCard(null);
    } finally {
      pruning = false;
    }
  }

  /* ---- 1: minimum items on every step ------------------------------------ */
  function patchBlockReason() {
    var pricing = window.BBPricing;
    if (!pricing || typeof pricing.blockReason !== "function" || pricing.__launchFixes) return;
    var orig = pricing.blockReason;
    pricing.blockReason = function (step) {
      var s = this.summarize();
      var minItems = Number(cfg().rules && cfg().rules.minItems) || 3;
      if (s.count < minItems) return "min_items";
      return orig.call(this, step);
    };
    pricing.__launchFixes = true;
  }

  /* ---- 2: cart submit: gate, add first, remove old group after, show errors */
  function showError(err) {
    var text = "";
    if (err && typeof err === "object") text = err.description || err.message || "";
    else if (typeof err === "string") text = err;
    text = String(text || "").replace(/<[^>]+>/g, "").trim();
    if (!text || /^cart error$/i.test(text)) text = "We couldn't add your box to the cart. Please check your items and try again.";
    var c = cfg();
    c.alerts = c.alerts || {};
    c.alerts.messages = c.alerts.messages || {};
    c.alerts.messages.cart_error = text;
    var title = c.alerts.title;
    c.alerts.title = "Something went wrong";
    try { if (window.BBAlert) window.BBAlert.show("cart_error"); } catch (e) {}
    c.alerts.title = title;
  }

  function postJson(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.text().then(function (txt) {
        var data;
        try { data = JSON.parse(txt); } catch (e) { data = { status: res.status, message: txt.slice(0, 200) }; }
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function submit(options) {
    options = options || {};
    var cart = window.BBCart;
    if (cart.submitting) return;
    var step = window.BBStore.get().step || 1;
    var reason = window.BBPricing.blockReason(step);
    if (reason) {
      if (window.BBShell && window.BBShell.needSelection) window.BBShell.needSelection(step);
      return;
    }
    var items = window.BBStore.cartPayload();
    if (!items.length) {
      if (window.BBShell && window.BBShell.needSelection) window.BBShell.needSelection(step);
      return;
    }
    cart.submitting = true;
    var buttons = document.querySelectorAll("[data-bb-continue], [data-bb-checkout]");
    buttons.forEach(function (btn) {
      btn.classList.add("is-disabled");
      btn.setAttribute("aria-busy", "true");
    });
    var state = window.BBStore.get();
    var cartUrl = (cfg().steps && cfg().steps.cartUrl) || "/cart";

    function cartItems() {
      return fetch("/cart.js", { credentials: "same-origin" })
        .then(function (res) { return res.json(); })
        .then(function (c) { return c.items || []; })
        .catch(function () { return []; });
    }

    function applyBoxNumber(n) {
      items.forEach(function (item) {
        if (!item.properties) return;
        item.properties[PROP_BOX_N] = String(n);
        if (!item.properties[PROP_GROUP_LABEL]) item.properties[PROP_GROUP_LABEL] = "Gift box " + n;
      });
    }

    /* Keys of the old copy of an edited box, read BEFORE the add so the new
       lines (same _bb_box_id) are never removed. */
    function oldKeys(list) {
      if (!state.editing || !state.boxId) return [];
      return list.filter(function (it) {
        return it.properties && it.properties[PROP_BOX_ID] === state.boxId;
      }).map(function (it) { return it.key; });
    }

    cartItems()
      .then(function (list) {
        var order = [];
        list.forEach(function (it) {
          var id = it.properties && it.properties[PROP_BOX_ID];
          if (id && order.indexOf(id) === -1) order.push(id);
        });
        var pos = order.indexOf(state.boxId);
        applyBoxNumber(pos === -1 ? order.length + 1 : pos + 1);
        var keys = oldKeys(list);
        return postJson("/cart/add.js", { items: items }).then(function () {
          if (!keys.length) return;
          var updates = {};
          keys.forEach(function (k) { updates[k] = 0; });
          return postJson("/cart/update.js", { updates: updates }).catch(function (err) {
            /* The new box is in the cart; a leftover old copy is visible there
               and removable by hand, so don't fail the whole submit. */
            if (window.console) console.warn("[BB] old box copy not removed", err);
          });
        });
      })
      .then(function () {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        if (root.slice(-1) !== "/") root += "/";
        /* #15: with boxes already in the cart, "Checkout Now" becomes "Add to
           cart" and lands on the cart page, where the whole order (and Ship
           to multiple addresses) is in view. */
        var toCheckout = options.destination === "checkout" && !(window.__bbCartItems > 0);
        /* Notes for Back: bb-checkout-back.js reads bb_went_to_checkout on
           pageshow and sends a Back-from-checkout to the cart (its own wrapper
           of BBCart.submit was lost when this file replaced submit -- Moshe hit
           the "Keep Going!" alert on Back, Oct 27). bb_left_for_cart makes a
           Back from the cart page reload the builder instead of showing the
           stale review panel over an emptied state. */
        try {
          sessionStorage.setItem(toCheckout ? "bb_went_to_checkout" : "bb_left_for_cart", String(Date.now()));
        } catch (e) {}
        window.BBStore.clear({ silent: true });
        window.location.href = toCheckout ? root + "checkout" : cartUrl;
      })
      .catch(function (err) {
        cart.submitting = false;
        buttons.forEach(function (btn) { btn.removeAttribute("aria-busy"); });
        if (window.BBShell && window.BBShell.render) window.BBShell.render();
        if (window.console) console.error("[BB] cart add failed", err);
        showError(err);
      });
  }

  /* ---- 6: desktop sidebar: only the current step's section open --------- */
  var lastAccStep = null;
  function patchAccordions() {
    var shell = window.BBShell;
    if (!shell || typeof shell.syncAccordions !== "function" || shell.__bbAccPatched) return;
    var orig = shell.syncAccordions;
    shell.syncAccordions = function (step) {
      orig.apply(this, arguments);
      step = Number(step) || 1;
      if (step === lastAccStep) return; /* the core's own guard: act once per step change, never on every render */
      lastAccStep = step;
      if (window.matchMedia("(max-width: 799px)").matches) return;
      document.querySelectorAll("[data-bb-acc]").forEach(function (acc) {
        var key = acc.getAttribute("data-bb-acc");
        var active = (step === 1 && key === "goodies") || (step === 2 && key === "box") || (step === 3 && key === "card");
        acc.classList.toggle("is-open", active);
      });
    };
    shell.__bbAccPatched = true;
  }

  /* ---- 7: review step: no scroll gate on Checkout ------------------------ */
  function patchReviewGate() {
    /* The core resets __bbReviewSeen to false on bb:review-enter; this
       listener is added later, so it runs after and sets it straight back. */
    document.addEventListener("bb:review-enter", function () {
      window.__bbReviewSeen = true;
      try { if (window.BBShell && window.BBShell.render) window.BBShell.render(); } catch (e) {}
    });
    window.__bbReviewSeen = true;
  }

  /* ---- 8: desktop review: Checkout + cart option under the subtotal ------ */
  function syncSidebarActions() {
    var pane = document.querySelector("[data-bb-sidebar-review]");
    if (!pane) return;
    var box = pane.querySelector(".bb-sb-actions");
    if (!box) {
      box = document.createElement("div");
      box.className = "bb-sb-actions";
      box.innerHTML =
        '<button type="button" class="bb-btn bb-sb-actions__checkout" data-bb-sb-checkout><span></span>' +
          '<svg viewBox="0 0 20 12" aria-hidden="true"><path d="M1 6h16M12 1.5 17.5 6 12 10.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<p class="bb-sb-actions__note"></p>' +
        '<button type="button" class="bb-btn bb-sb-actions__cart" data-bb-sb-cart></button>';
      pane.appendChild(box);
      box.addEventListener("click", function (e) {
        var target = null;
        if (e.target.closest("[data-bb-sb-checkout]")) target = document.querySelector("[data-bb-continue]");
        else if (e.target.closest("[data-bb-sb-cart]")) target = document.querySelector(".bb-review__checkout[data-bb-checkout]");
        if (target) { e.preventDefault(); target.click(); }
      });
    }
    var stepLabel = document.querySelector("[data-bb-continue-label]");
    var cartBtn = document.querySelector(".bb-review__checkout[data-bb-checkout]");
    var note = document.querySelector(".bb-review__cart-note");
    box.querySelector("[data-bb-sb-checkout] span").textContent =
      (stepLabel && stepLabel.textContent.trim()) || "Checkout Now";
    box.querySelector("[data-bb-sb-cart]").textContent =
      (cartBtn && cartBtn.textContent.trim()) || "Add to cart";
    var noteEl = box.querySelector(".bb-sb-actions__note");
    noteEl.textContent = note ? note.textContent.trim() : "";
    noteEl.hidden = !noteEl.textContent;
    box.querySelector("[data-bb-sb-cart]").hidden = !cartBtn;
  }

  /* ---- 9: step changes land at the top ----------------------------------- */
  function patchStepScroll() {
    var steps = window.BBSteps;
    if (!steps || typeof steps.go !== "function" || steps.__bbScrollPatched) return;
    var orig = steps.go;
    steps.go = function (step) {
      var before = window.BBStore && window.BBStore.get ? (window.BBStore.get().step || 1) : null;
      var r = orig.apply(this, arguments);
      var after = window.BBStore && window.BBStore.get ? (window.BBStore.get().step || 1) : null;
      if (before !== after) {
        window.scrollTo(0, 0);
        window.setTimeout(function () { window.scrollTo(0, 0); }, 360);
      }
      return r;
    };
    steps.__bbScrollPatched = true;
  }

  /* ---- 10: popup gallery + zoom (phones) ---------------------------------
     First version made a tap on the popup photo open the zoom viewer, which
     fought bb-modal-sheet.js (a tap there shows the NEXT image), so the
     viewer opened on the wrong photo and the gallery felt gone (Moshe, Oct
     27 night). Now: swipe left/right (or tap) changes the image, small dots
     under it say how many there are, thumbnails stay hidden, and a "view
     larger" pill on the photo opens the viewer on the image on screen.
     Inside the viewer a tap toggles 2.5x and the photo can be dragged. */
  function patchZoom() {
    if (window.__bbZoomPlus) return;
    window.__bbZoomPlus = true;
    var phone = function () { return window.matchMedia("(max-width: 799px)").matches; };

    function thumbsOf(modal) {
      return modal ? Array.prototype.slice.call(modal.querySelectorAll("[data-bb-modal-thumb]")) : [];
    }
    function activeIndex(thumbs) {
      for (var k = 0; k < thumbs.length; k++) if (thumbs[k].classList.contains("is-active")) return k;
      return 0;
    }
    function step(modal, dir) {
      var thumbs = thumbsOf(modal);
      if (thumbs.length < 2) return;
      thumbs[(activeIndex(thumbs) + dir + thumbs.length) % thumbs.length].click();
    }

    /* The pill and the dots live inside the stage; (re)built when the popup
       opens, kept in step with the hidden thumbnails. */
    function dress(modal) {
      var stage = modal.querySelector(".bb-modal__stage");
      if (!stage) return;
      var pill = stage.querySelector("[data-bb-modal-zoom]");
      if (!pill) {
        pill = document.createElement("button");
        pill.type = "button";
        pill.className = "bb-modal__zoom";
        pill.setAttribute("data-bb-modal-zoom", "");
        pill.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="7" cy="7" r="4.2" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="m10.2 10.2 3 3" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
          ((cfg().copy && cfg().copy.viewLarger) || "view larger");
        pill.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation(); /* not a tap on the photo: no image change */
          var img = stage.querySelector("[data-bb-modal-image]");
          var src = img && (img.currentSrc || img.src);
          if (src && window.BBZoom && window.BBZoom.open) window.BBZoom.open(src, img.alt || "");
        });
        stage.appendChild(pill);
      }
      var dots = stage.querySelector("[data-bb-modal-dots]");
      if (!dots) {
        dots = document.createElement("div");
        dots.className = "bb-modal__dots";
        dots.setAttribute("data-bb-modal-dots", "");
        dots.addEventListener("click", function (e) {
          var d = e.target.closest("[data-bb-modal-dot]");
          if (!d) return;
          e.stopPropagation();
          var thumbs = thumbsOf(modal);
          var i = parseInt(d.getAttribute("data-bb-modal-dot"), 10) || 0;
          if (thumbs[i]) thumbs[i].click();
        });
        stage.appendChild(dots);
      }
      var thumbs = thumbsOf(modal);
      var on = activeIndex(thumbs);
      dots.hidden = thumbs.length < 2;
      dots.innerHTML = thumbs.map(function (t, i) {
        return '<button type="button" class="bb-modal__dot' + (i === on ? " is-active" : "") + '" data-bb-modal-dot="' + i + '" aria-label="Photo ' + (i + 1) + '"></button>';
      }).join("");
    }

    var modal = document.querySelector("[data-bb-modal]");
    if (modal && window.MutationObserver) {
      var thumbsWrap = modal.querySelector("[data-bb-modal-thumbs]");
      var sync = function () { if (!modal.hidden) dress(modal); };
      new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ["hidden", "class"] });
      if (thumbsWrap) new MutationObserver(sync).observe(thumbsWrap, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
      sync();

      /* Swipe on the photo: next / previous image. */
      var sx = null, sy = null;
      modal.addEventListener("touchstart", function (e) {
        if (!e.target.closest(".bb-modal__stage") || e.touches.length !== 1) { sx = null; return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      modal.addEventListener("touchend", function (e) {
        if (sx === null || !phone()) return;
        var t = e.changedTouches && e.changedTouches[0];
        if (!t) { sx = null; return; }
        var dx = t.clientX - sx, dy = t.clientY - sy;
        sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          step(modal, dx < 0 ? 1 : -1);
          modal.__bbSwiped = Date.now();
        }
      });
      /* A swipe must not also count as the sheet's tap-to-advance. */
      modal.addEventListener("click", function (e) {
        if (modal.__bbSwiped && Date.now() - modal.__bbSwiped < 500 && e.target.closest(".bb-modal__stage") &&
            !e.target.closest("[data-bb-modal-zoom], [data-bb-modal-dots]")) {
          e.stopPropagation();
          e.preventDefault();
        }
      }, true);
    }

    /* Inside the viewer: tap toggles 2.5x, centred on the tapped spot. */
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var zoomImg = e.target.closest("[data-bb-zoom-img]");
      if (!zoomImg) return;
      var dialog = zoomImg.closest(".bb-zoom__dialog");
      if (!dialog) return;
      var on = !dialog.classList.contains("is-zoomed");
      var rx = (e.clientX - dialog.getBoundingClientRect().left) / dialog.clientWidth;
      var ry = (e.clientY - dialog.getBoundingClientRect().top) / dialog.clientHeight;
      dialog.classList.toggle("is-zoomed", on);
      if (on) {
        dialog.scrollLeft = Math.max(0, zoomImg.offsetWidth * rx - dialog.clientWidth / 2);
        dialog.scrollTop = Math.max(0, zoomImg.offsetHeight * ry - dialog.clientHeight / 2);
      } else {
        dialog.scrollLeft = 0; dialog.scrollTop = 0;
      }
    });
    /* Fresh viewer each time it opens. */
    var root = document.querySelector("[data-bb-zoom]");
    if (root && window.MutationObserver) {
      new MutationObserver(function () {
        if (!root.hidden) {
          var d = root.querySelector(".bb-zoom__dialog");
          if (d) { d.classList.remove("is-zoomed"); d.scrollLeft = 0; d.scrollTop = 0; }
        }
      }).observe(root, { attributes: true, attributeFilter: ["hidden"] });
    }
  }

  /* ---- 11: Back in the step bar (shown on phones at step 4 by CSS) ------- */
  function addStepbarBack() {
    var action = document.querySelector(".bb-stepbar__action");
    if (!action || action.querySelector(".bb-stepbar__back")) return;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "bb-stepbar__back";
    btn.setAttribute("aria-label", "Back");
    btn.innerHTML = '<svg viewBox="0 0 20 12" aria-hidden="true"><path d="M19 6H3M8 1.5 2.5 6 8 10.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btn.addEventListener("click", function () {
      var panel = document.querySelector('[data-bb-panel="4"]');
      var back = panel && panel.querySelector("[data-bb-back]");
      if (back) back.click();
      else if (window.BBSteps) window.BBSteps.go(3, { force: true });
    });
    var cont = action.querySelector("[data-bb-continue]");
    action.insertBefore(btn, cont || null);
  }

  /* ---- 12: drawer top padding = measured nav overlap ---------------------- */
  function padDrawer() {
    var main = document.querySelector("main.bb-builder-page");
    var sec = main && main.querySelector(".shopify-section.bb-shopify-sidebar");
    if (!sec || !main.classList.contains("bb-sidebar-open")) return;
    if (!window.matchMedia("(max-width: 799px)").matches) { sec.style.paddingTop = ""; return; }
    /* Take four (Oct 27, 11pm): the panel is full screen and sits ABOVE the
       nav (bb-launch-tweaks.css), so no allowance is needed any more. */
    sec.style.paddingTop = "";
  }
  function watchDrawer() {
    var main = document.querySelector("main.bb-builder-page");
    if (!main || !window.MutationObserver) return;
    new MutationObserver(function () { padDrawer(); window.requestAnimationFrame(padDrawer); })
      .observe(main, { attributes: true, attributeFilter: ["class"] });
    window.addEventListener("resize", padDrawer);
  }

  /* #13 (Oct 27 night): every greeting card is $0, so "$0.00" next to The
     Card in the Box Summary, on its line and on the review block was noise
     (Moshe). Blanked whenever the chosen card's price is 0; a card with a
     real price shows it as before (the core rewrites the text each render). */
  function hideZeroCardPrice() {
    var state;
    try { state = window.BBStore.get(); } catch (e) { return; }
    var card = state && state.card;
    /* No card picked counts as zero too: the review block says "No card
       selected" and printed $0.00 beside it. */
    var zero = !(card && card.variantId && Number(card.price) > 0);
    if (!zero) return;
    document.querySelectorAll("[data-bb-card-acc-price]").forEach(function (el) {
      el.textContent = "";
      el.hidden = true;
    });
    document.querySelectorAll("[data-bb-card-line-price], [data-bb-review-card-total]").forEach(function (el) {
      el.textContent = "";
    });
    /* The desktop sidebar receipt prints "<card> 1 x $0.00" as its last row. */
    document.querySelectorAll("[data-bb-review-receipt] li").forEach(function (li) {
      var name = li.querySelector(".bb-review-receipt__name");
      var qty = li.querySelector(".bb-review-receipt__qty");
      if (name && qty && card && name.textContent.trim() === String(card.title || "").trim()) qty.textContent = "";
    });
  }
  function watchCardPrice() {
    var run = function () {
      hideZeroCardPrice();
      window.requestAnimationFrame(hideZeroCardPrice);
    };
    document.addEventListener("bb:shell-render", run);
    document.addEventListener("bb:state", run);
    run();
  }

  /* #14 (Oct 27 night): the phone drawer is a bottom sheet (bb-launch-tweaks
     .css). Tapping the dimmed gap above it, or dragging it down by more than
     ~90px, closes it the same way the nav X does. A drag only counts when
     the sheet is scrolled to its top and the finger moves mostly downward,
     so normal scrolling inside the sheet is untouched. */
  function sheetGestures() {
    var main = document.querySelector("main.bb-builder-page");
    var sec = main && main.querySelector(".shopify-section.bb-shopify-sidebar");
    var sheet = sec && sec.querySelector(".bb-sidebar");
    if (!sec || !sheet || sec.__bbSheet) return;
    sec.__bbSheet = true;
    var phone = function () { return window.matchMedia("(max-width: 799px)").matches; };
    var closeIt = function () {
      var t = document.querySelector("[data-bb-sidebar-toggle]");
      if (t && main.classList.contains("bb-sidebar-open")) t.click();
    };
    var reset = function () {
      sheet.classList.remove("is-dragging", "is-settling");
      sheet.style.marginTop = "";
    };
    /* A tap on the gap already closes the sheet: the core treats any click
       outside [data-bb-sidebar] as "close" (box-builder.js ~1407). */
    var startY = null, startX = null, dragging = false, dy = 0, lastY = 0, lastT = 0, vel = 0;
    sec.addEventListener("touchstart", function (e) {
      if (!phone() || e.touches.length !== 1) return;
      startY = e.touches[0].clientY; startX = e.touches[0].clientX; dragging = false; dy = 0;
      lastY = startY; lastT = e.timeStamp; vel = 0;
    }, { passive: true });
    sec.addEventListener("touchmove", function (e) {
      if (startY === null || !phone()) return;
      var y = e.touches[0].clientY, x = e.touches[0].clientX;
      var ddy = y - startY, ddx = x - startX;
      if (!dragging) {
        if (sec.scrollTop > 0 || ddy < -8 || Math.abs(ddx) > 8 && Math.abs(ddx) > ddy) { startY = null; return; }
        /* At the top and moving down: stop the browser's own overscroll /
           pull-to-refresh from the very first move (Chrome on iPhone
           reloaded the page), then start the drag once it is clearly one. */
        if (ddy > 0 && e.cancelable) e.preventDefault();
        if (ddy < 6) return;
        dragging = true;
        sheet.classList.add("is-dragging");
        sheet.classList.remove("is-settling");
      }
      dy = Math.max(0, ddy);
      /* Velocity (px/ms) over the last move, for the flick test below. */
      var dt = e.timeStamp - lastT;
      if (dt > 0) vel = (y - lastY) / dt;
      lastY = y; lastT = e.timeStamp;
      sheet.style.marginTop = dy + "px";
      if (e.cancelable) e.preventDefault();
    }, { passive: false });
    var end = function () {
      if (!dragging) { startY = null; return; }
      dragging = false; startY = null;
      sheet.classList.remove("is-dragging");
      /* Moshe, 11:15pm: "the drag is too fast" - closing at 90px felt like
         it flew away. Now it closes only past about a third of the screen
         (never under 140px), or on a real flick (fast and already 50px+);
         anything less eases back. The close itself slides out over 340ms
         (was 200ms to 110vh) so the panel visibly leaves instead of
         vanishing. */
      var limit = Math.max(140, window.innerHeight * 0.33);
      var flick = vel > 1.1 && dy > 50;
      if (dy > limit || flick) {
        sheet.classList.add("is-settling");
        sheet.style.marginTop = "100vh";
        window.setTimeout(function () { closeIt(); reset(); }, 340);
      } else {
        sheet.classList.add("is-settling");
        sheet.style.marginTop = "";
        window.setTimeout(reset, 360);
      }
    };
    sec.addEventListener("touchend", end);
    sec.addEventListener("touchcancel", end);
    /* Fresh on every open. */
    if (window.MutationObserver) {
      new MutationObserver(function () { if (!main.classList.contains("bb-sidebar-open")) reset(); })
        .observe(main, { attributes: true, attributeFilter: ["class"] });
    }
  }

  /* #15 (Moshe, Oct 27 night): if the cart already holds a box or two, the
     review step's primary button is "Add to cart" (to the cart page) instead
     of "Checkout Now", and the secondary cart option goes away since it would
     say the same thing. /cart.js is read on boot and again on entering the
     review step; the main element gets .bb-cart-has-items for the CSS. */
  function checkCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        window.__bbCartItems = (c && c.items && c.items.length) || 0;
        var main = document.querySelector("main.bb-builder-page");
        if (main) main.classList.toggle("bb-cart-has-items", window.__bbCartItems > 0);
        relabel();
      })
      .catch(function () {});
  }
  function relabel() {
    if (!(window.__bbCartItems > 0)) return;
    var state;
    try { state = window.BBStore.get(); } catch (e) { return; }
    if ((state.step || 1) !== 4 || state.editing) return;
    var copy = cfg().copy || {};
    document.querySelectorAll("[data-bb-continue] [data-bb-continue-label]").forEach(function (el) {
      el.textContent = copy.addToCart || "Add to cart";
    });
  }
  function watchCart() {
    checkCart();
    document.addEventListener("bb:review-enter", checkCart);
    document.addEventListener("bb:shell-render", function () { relabel(); window.requestAnimationFrame(relabel); });
    /* Back from the cart page: the builder comes out of the back-forward
       cache showing the old review panel over an emptied state. Reload so
       it starts clean (bb-checkout-back.js handles Back from checkout). */
    window.addEventListener("pageshow", function (e) {
      var note = null;
      try { note = sessionStorage.getItem("bb_left_for_cart"); } catch (err) {}
      if (!note) return;
      try { sessionStorage.removeItem("bb_left_for_cart"); } catch (err) {}
      if (e.persisted) window.location.reload();
    });
  }

  /* #16 (Moshe, Oct 28, 12:40am): the free-shipping line is one plain line
     everywhere (bb-launch-tweaks.css). The core prints the theme setting
     "You are $63.00 away from Free Shipping!"; that reads number-first here
     ("$63.00 more for free shipping"), the unlocked line loses its "!" and
     gets "free shipping" in red, and the element carries .is-unlocked for
     the check icon. Runs after every render; other wordings are left alone. */
  function tidyShipping() {
    var unlocked = false;
    try { unlocked = !!window.BBPricing.summarize().freeShippingUnlocked; } catch (e) {}
    document.querySelectorAll("[data-bb-shipping]").forEach(function (el) {
      el.classList.toggle("is-unlocked", unlocked);
      var html = el.innerHTML;
      /* "$80" rather than "$80.00", and a capital F on the empty-box line
         ("free shipping on orders over $100" is how the core prints it). */
      html = html.replace(/\$(\d[\d,]*)\.00(?=\D|$)/g, "$$$1");
      html = html.replace(/^(\s*<span class="bb-sidebar__ship-amt">)free/, "$1Free");
      var m = html.match(/^\s*You are\s+(<span class="bb-sidebar__ship-amt">[^<]*<\/span>)\s+away from Free Shipping!?\s*$/i);
      if (m) { el.innerHTML = m[1] + " more for free shipping"; return; }
      if (unlocked && /unlocked free shipping/i.test(html) && html.indexOf("bb-sidebar__ship-amt") === -1) {
        html = html.replace(/free shipping!?/i, '<span class="bb-sidebar__ship-amt">free shipping</span>');
      }
      if (html !== el.innerHTML) el.innerHTML = html;
    });
  }
  function watchShipping() {
    var run = function () { tidyShipping(); window.requestAnimationFrame(tidyShipping); };
    document.addEventListener("bb:shell-render", run);
    document.addEventListener("bb:state", run);
    run();
  }

  /* #17 (Moshe, Oct 28, 10:00am): the size explainer under "How full is
     your box" (section setting sizing_message) vanished as soon as the box
     held one item - the core blanks [data-bb-sizing-msg] whenever count > 0
     and the tier is still Small, and only fills it again with "Your box
     upgraded to ..." (is-upgraded). The explainer now stays until that
     upgrade line takes over. The default text is read once from the
     Liquid-rendered element. (Earlier today #17 moved the free-shipping
     line into the box-size card; that is undone - it is back under the
     title.) */
  function keepSizingMsg() {
    var els = document.querySelectorAll("[data-bb-sizing-msg]");
    /* The setting is also in BBConfig.sizing.message (sidebar config
       island), which is safer than reading the element: with a saved box
       the core has usually rendered - and blanked it - before this runs. */
    var fromCfg = function () { return String((cfg().sizing && cfg().sizing.message) || "").trim(); };
    els.forEach(function (el) {
      if (!el.hasAttribute("data-bb-msg-default")) el.setAttribute("data-bb-msg-default", fromCfg() || el.textContent.trim());
    });
    /* 10:12am: no "Your box upgraded to Regular." either - the explainer is
       the only line, always (the meter's highlighted label shows the size). */
    var restore = function () {
      els.forEach(function (el) {
        var def = el.getAttribute("data-bb-msg-default") || fromCfg();
        el.classList.remove("is-upgraded");
        if (def && el.textContent.trim() !== def) el.textContent = def;
      });
    };
    document.addEventListener("bb:shell-render", function () { restore(); window.requestAnimationFrame(restore); });
    document.addEventListener("bb:state", restore);
    restore();
  }

  /* #18 (Moshe, Oct 28, 10:05am): on phones the old builder kept a sticky
     free-shipping bar in view the whole time; here the line lived only in
     the panel. Rather than add another fixed strip (nav + filters + strip +
     step bar would eat a third of an iPhone SE), the nudge goes into the
     step bar's "Your box" block, which is already sticky on every step:
     "Your box · $13.00" over "$87 to free shipping" (count stays on the
     icon badge). Styles: bb-launch-tweaks.css. Phones only (the block is
     hidden on desktop by bb-qa-overrides.css). */
  function stepbarShipping() {
    var copy = document.querySelector(".bb-stepbar__mybox-copy");
    if (!copy || copy.__bbShip) return;
    copy.__bbShip = true;
    var total = copy.querySelector("[data-bb-box-total]");
    var strong = copy.querySelector("strong");
    /* The second line is the DIRECT child span; pick it before the total
       moves into <strong>, or querySelector("span") finds the moved total
       first (10:20am on the phone: "Your box · $73 to free shipping" with a
       lone dot underneath). */
    var line = copy.querySelector(":scope > span");
    if (strong && total) {
      strong.appendChild(document.createTextNode(" · "));
      strong.appendChild(total); /* the core keeps updating it by selector */
    }
    if (line) {
      line.className = "bb-stepbar__mybox-ship";
      line.setAttribute("data-bb-mybox-ship", "");
    }
    var short = function (cents) {
      var t = "";
      try { t = window.BBMoney.format(cents); } catch (e) { t = "$" + Math.round(cents / 100); }
      return t.replace(/\.00(?=\D|$)/, "");
    };
    var sync = function () {
      var el = copy.querySelector("[data-bb-mybox-ship]");
      if (!el) return;
      var goal = Number(cfg().freeShippingCents) || 0;
      if (!goal) { el.hidden = true; return; }
      var s;
      try { s = window.BBPricing.summarize(); } catch (e) { return; }
      el.hidden = false;
      el.classList.toggle("is-unlocked", !!s.freeShippingUnlocked);
      if (s.freeShippingUnlocked) {
        el.innerHTML = "Free shipping unlocked";
      } else if (!s.count) {
        el.innerHTML = "Free shipping over " + short(goal);
      } else {
        el.innerHTML = '<b class="bb-sidebar__ship-amt">' + short(s.freeShippingRemaining) + "</b> to free shipping";
      }
    };
    document.addEventListener("bb:shell-render", function () { sync(); window.requestAnimationFrame(sync); });
    document.addEventListener("bb:state", sync);
    sync();
  }

  function patchSubmit() {
    if (!window.BBCart || window.BBCart.__launchFixes) return;
    window.BBCart.submit = submit;
    window.BBCart.__launchFixes = true;
  }

  function boot() {
    if (!window.BBPricing || !window.BBStore || !window.BBCart) return false;
    fixBoxes();
    pruneMissing();
    /* Edit-from-cart fills the box asynchronously (after /cart.js), so check
       again whenever the state changes; a no-op once everything is known. */
    document.addEventListener("bb:state", function () { pruneMissing(); });
    patchBlockReason();
    patchSubmit();
    patchAccordions();
    patchReviewGate();
    syncSidebarActions();
    document.addEventListener("bb:shell-render", syncSidebarActions);
    patchStepScroll();
    patchZoom();
    addStepbarBack();
    watchDrawer();
    watchCardPrice();
    sheetGestures();
    watchCart();
    keepSizingMsg();
    watchShipping();
    stepbarShipping();
    try { if (window.BBShell && window.BBShell.render) window.BBShell.render(); } catch (e) {}
    return true;
  }

  if (!boot()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (boot() || ++tries > 200) clearInterval(iv);
    }, 50);
  }
})();
